import { render, staticRenderFns } from "./ColorDisplay.vue?vue&type=template&id=54a85ba4"
import script from "./ColorDisplay.js?vue&type=script&lang=js&external"
export * from "./ColorDisplay.js?vue&type=script&lang=js&external"
import style0 from "./ColorDisplay.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports